<header class="hhsg-page-header">
    <hhsg-breadcrumbs auto="true" *ngIf="showBreadCrumb"></hhsg-breadcrumbs>
    <div class="header-content">
        <h2 class="title">
            <span *ngIf="isIconBeforeHeaderText && headerIcon" class="material-symbols-outlined header-before-icon" (click)="onHeaderIcon()">
                {{headerIcon}}
            </span>
            
            {{headerText}}

            <span *ngIf="!isIconBeforeHeaderText && headerIcon" class="material-symbols-outlined header-after-icon" (click)="onHeaderIcon()">
                {{headerIcon}}
            </span>
        </h2>
        <p class="subtitle">{{subHeaderText}}</p>
        <ng-content></ng-content>
    </div>    
    <div class="header-buttons">
        <ng-content select="[header-buttons]"></ng-content>
    </div>
</header>
<hr *ngIf="displayDivider"/>